export const BadgeCheck = ({ variant = 'default' }: { variant?: 'default' | 'simple' }) => {
  if (variant === 'simple') {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 1L9.76 2.4317L12 2.0718L12.8083 4.19167L14.9282 5L14.5683 7.24003L16 9L14.5683 10.76L14.9282 13L12.8083 13.8083L12 15.9282L9.76 15.5683L8 17L6.24003 15.5683L4 15.9282L3.19167 13.8083L1.0718 13L1.4317 10.76L0 9L1.4317 7.24003L1.0718 5L3.19167 4.19167L4 2.0718L6.24003 2.4317L8 1Z"
          fill="#10B981"
        />
        <path d="M5.375 9L7.375 11L10.575 7.4" stroke="white" strokeWidth="1.6" />
      </svg>
    );
  }

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_5233_1335)">
        <path
          d="M10 0L11.76 1.4317L14 1.0718L14.8083 3.19167L16.9282 4L16.5683 6.24003L18 8L16.5683 9.75997L16.9282 12L14.8083 12.8083L14 14.9282L11.76 14.5683L10 16L8.24003 14.5683L6 14.9282L5.19167 12.8083L3.0718 12L3.4317 9.75997L2 8L3.4317 6.24003L3.0718 4L5.19167 3.19167L6 1.0718L8.24003 1.4317L10 0Z"
          fill="#EFF2FF"
        />
      </g>
      <path d="M6.71879 7.5L9.21878 10L13.7188 5.5" stroke="#00BD59" strokeWidth="2" />
      <defs>
        <filter
          id="filter0_d_5233_1335"
          x="0"
          y="0"
          width="20"
          height="20"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.660344 0 0 0 0 0.310956 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5233_1335" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5233_1335"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
